import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';

export const useOwner = () => {
  const { user } = useAuth();
  const [ownerId, setOwnerId] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;

    const getOwner = async () => {
      // Check if this user is a team member
      const { data: membership } = await supabase
        .from('team_members')
        .select('owner_id, role')
        .eq('user_id', user.id)
        .maybeSingle();

      if (membership) {
        // This user is a team member — use the owner's ID
        setOwnerId(membership.owner_id);
        setRole(membership.role);
      } else {
        // This user is an owner — use their own ID
        setOwnerId(user.id);
        setRole('owner');
      }
      setLoading(false);
    };

    getOwner();
  }, [user]);

  return { ownerId, role, loading, isOwner: role === 'owner', isAdmin: role === 'admin' || role === 'owner', isEditor: role === 'editor', isViewer: role === 'viewer' };
};